export default {"src":"/_next/static/media/skills.fa78c4b5.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};